import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container pt-2" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-lg-6 col-xl-5 mb-2" }
const _hoisted_4 = { class: "input-group input-group-sm" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-12 col-lg-6 col-xl-5 mb-2" }
const _hoisted_8 = { class: "col-12 col-lg-6 col-xl-7" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 mt-2" }
const _hoisted_13 = { class: "col-12 col-xl-6 mt-2" }
const _hoisted_14 = { class: "col-12 col-xl-6 mt-2" }
const _hoisted_15 = { class: "col-12 mt-2" }
const _hoisted_16 = { class: "col-12 mt-2" }
const _hoisted_17 = { class: "row text-center" }
const _hoisted_18 = {
  key: 0,
  class: "col-12 col-md-8 col-lg-6 col-xl-4 mx-auto mt-3"
}
const _hoisted_19 = {
  key: 1,
  class: "col-12 col-md-8 col-lg-6 col-xl-4 mx-auto mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_card = _resolveComponent("profile-card")!
  const _component_telegram_unlink = _resolveComponent("telegram-unlink")!
  const _component_activate_gtr_basic = _resolveComponent("activate-gtr-basic")!
  const _component_activate_cmmi = _resolveComponent("activate-cmmi")!
  const _component_carrer_summary_table = _resolveComponent("carrer-summary-table")!
  const _component_change_user_email = _resolveComponent("change-user-email")!
  const _component_create_quote = _resolveComponent("create-quote")!
  const _component_activate_quote = _resolveComponent("activate-quote")!
  const _component_add_commission_record = _resolveComponent("add-commission-record")!
  const _component_adjust_points = _resolveComponent("adjust-points")!
  const _component_user_not_found = _resolveComponent("user-not-found")!
  const _component_searching = _resolveComponent("searching")!
  const _component_error_modal = _resolveComponent("error-modal")!
  const _component_information_modal = _resolveComponent("information-modal")!
  const _component_profile_picture_gallery_modal = _resolveComponent("profile-picture-gallery-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Usuario / Correo Electrónico",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.username !== '' && !_ctx.searching && _ctx.searchUser()), ["enter"]))
            }, null, 544), [
              [
                _vModelText,
                _ctx.username,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("button", {
              class: "btn btn-outline-secondary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args))),
              disabled: _ctx.username == '' || _ctx.searching
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-search" }, null, -1),
              _createTextVNode(" Buscar ", -1)
            ]))], 8, _hoisted_5)
          ])
        ])
      ]),
      (_ctx.userData.username)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_profile_card, { user: _ctx.userData }, null, 8, ["user"]),
              _createVNode(_component_telegram_unlink, {
                class: "mt-2",
                username: _ctx.userData.usernamePK,
                "telegram-bot-user-data": _ctx.userData.telegramBotUserData,
                onError: _ctx.showError
              }, null, 8, ["username", "telegram-bot-user-data", "onError"]),
              _createVNode(_component_activate_gtr_basic, {
                class: "mt-2",
                email: _ctx.userData.contact.email.data,
                username: _ctx.userData.usernamePK,
                subscriptions: _ctx.userData.subscriptions,
                onUserActivated: _ctx.userActivated,
                onError: _ctx.showError
              }, null, 8, ["email", "username", "subscriptions", "onUserActivated", "onError"]),
              _createVNode(_component_activate_cmmi, {
                class: "mt-2",
                username: _ctx.userData.usernamePK,
                subscriptions: _ctx.userData.subscriptions,
                onCmmiActivated: _ctx.cmmiActivated,
                onError: _ctx.showError
              }, null, 8, ["username", "subscriptions", "onCmmiActivated", "onError"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_carrer_summary_table, {
                    class: "border rounded bg-light col-12",
                    "user-data": _ctx.userData,
                    "display-footer": false
                  }, null, 8, ["user-data"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_change_user_email, {
                    email: _ctx.userData.contact.email.data,
                    username: _ctx.userData.usernamePK,
                    onEmailUpdated: _ctx.updateEmail,
                    onError: _ctx.showError
                  }, null, 8, ["email", "username", "onEmailUpdated", "onError"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_create_quote, {
                    class: "h-100",
                    email: _ctx.userData.contact.email.data,
                    username: _ctx.userData.usernamePK,
                    subscriptions: _ctx.userData.subscriptions,
                    onQuoteCreated: _ctx.quoteCreated,
                    onError: _ctx.showError
                  }, null, 8, ["email", "username", "subscriptions", "onQuoteCreated", "onError"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_activate_quote, {
                    class: "h-100",
                    username: _ctx.userData.usernamePK,
                    onQuoteActivated: _ctx.quoteActivated,
                    onError: _ctx.showError
                  }, null, 8, ["username", "onQuoteActivated", "onError"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_add_commission_record, {
                    email: _ctx.userData.contact.email.data,
                    username: _ctx.userData.usernamePK,
                    onCommissionAdded: _ctx.commissionAdded,
                    onError: _ctx.showError
                  }, null, 8, ["email", "username", "onCommissionAdded", "onError"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_adjust_points, {
                    username: _ctx.userData.usernamePK,
                    onPointsAdjusted: _ctx.pointsAdjusted,
                    onError: _ctx.showError
                  }, null, 8, ["username", "onPointsAdjusted", "onError"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.notFound)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_user_not_found)
            ]))
          : _createCommentVNode("", true),
        (_ctx.searching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_searching)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_error_modal, {
      title: _ctx.errorTitle,
      message: _ctx.errorMessage
    }, null, 8, ["title", "message"]),
    _createVNode(_component_information_modal, {
      title: _ctx.informationTitle,
      message: _ctx.informationMessage
    }, null, 8, ["title", "message"]),
    _createVNode(_component_profile_picture_gallery_modal)
  ], 64))
}